(function(){
    angular
        .module('app')
        .directive('ngScroll', onscroll);

        onscroll.$inject = ['$timeout'];
        function onscroll($timeout){
            return {
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("name");
                    $element.css({"max-height":($(window).height()-250)+"px"});
                    //console.log(scope);
                    $element.on("scroll", function() {
			            if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				    		scope.callListaFoto();
				        }
			        });
                });
            }
          }
      }
})();